import { render, staticRenderFns } from "./autoRenewal.vue?vue&type=template&id=64fb5f35&scoped=true&"
import script from "./autoRenewal.vue?vue&type=script&lang=js&"
export * from "./autoRenewal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fb5f35",
  null
  
)

export default component.exports